import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from "../../../assets/image/image-page-banner.webp";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import TextBlock from "../../../components/sections/front/Common/TextBlock";
import SectionContact from "../../../components/sections/front/Contact/SectionContact";
import { useBanner } from "../../../providers/BannerProviders";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const { data } = useBanner();
  const contactBanner = data?.data?.find(
    (item) => item?.bannerType === "contact"
  );
  return (
    <>
      {contactBanner && (
        <Helmet>
          <title>{contactBanner.seoTitle}</title>
          <meta
            name="description"
            property="og:description"
            content={contactBanner.seoDescription}
          />
          <meta
            name="keywords"
            property="og:keywords"
            content={contactBanner.seoKeyword}
          />
          <meta
            name="author"
            property="og:author"
            content={contactBanner.seoAuthor}
          />
          <meta
            property="og:image"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:secure_url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
        </Helmet>
      )}
      <PageBanner
        title={contactBanner?.title}
        image={contactBanner?.image?.url}
      />

      <TextBlock description={contactBanner?.contentDescription} />
      <SectionContact />
      <OurPartners />
    </>
  );
};

export default Contact;
